import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/site';

export default function CtaSection() {
  return (
    <section className="w-full bg-secondary-950 py-14 md:py-20">
      <div className="mx-auto w-full max-w-content px-4 md:px-6">
        <div className="flex flex-col items-start gap-8 lg:flex-row lg:items-center lg:justify-between">
          <div className="max-w-2xl">
            <p className="flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-accent-400">
              <span className="h-px w-8 bg-accent-500" aria-hidden="true" />
              Stay On Track
            </p>
            <h2 className="mt-4 font-heading text-2xl font-bold text-background-50 md:text-3xl">
              把这份更新追踪表收藏起来
            </h2>
            <p className="mt-4 text-sm leading-7 text-background-300 md:text-base">
              想看哪部剧、更新到第几集、下一集什么时候来，都能在一个地方对上。有新剧上线或档期调整，我们会在页面同步修订。
            </p>
          </div>
          <div className="flex w-full flex-col gap-3 sm:flex-row lg:w-auto">
            <Link
              to="/dramas"
              className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm text-secondary-950 transition-colors hover:bg-accent-400"
            >
              <i className="ri-play-list-2-line" aria-hidden="true" />
              挑选要追的剧
            </Link>
            <Link
              to="/about"
              className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-secondary-700 px-6 py-3 text-sm text-background-100 transition-colors hover:border-accent-400 hover:text-accent-400"
            >
              <i className="ri-mail-send-line" aria-hidden="true" />
              联系我们推荐
            </Link>
          </div>
        </div>
        <p className="mt-8 flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-background-400">
          <i className="ri-mail-line" aria-hidden="true" />
          推荐剧集或反馈问题：{siteInfo.email}
        </p>
      </div>
    </section>
  );
}